import AXIOS from "./axios";

// FERRAMENTA DE DIAGNÓSTICO TEMPORÁRIA — ver utils/prescriptionDiagnostic.js.
// Espelha os três endpoints de `gateway_medical_prescriptions/diagnostics`.
// Todos respondem 403 se a conta autenticada não for a de diagnóstico.
export class PrescriptionDiagnostics {
  static listDoctors() {
    return AXIOS.get("gateway_medical_prescriptions/diagnostics/doctors");
  }

  static listAppointments(doctorId) {
    return AXIOS.get(
      `gateway_medical_prescriptions/diagnostics/doctors/${doctorId}/appointments`
    );
  }

  static token(doctorId) {
    return AXIOS.get(
      `gateway_medical_prescriptions/diagnostics/doctors/${doctorId}/token`
    );
  }
}
